import { render, staticRenderFns } from "./Desk.vue?vue&type=template&id=f39636be&scoped=true&"
import script from "./Desk.vue?vue&type=script&lang=js&"
export * from "./Desk.vue?vue&type=script&lang=js&"
import style0 from "./Desk.vue?vue&type=style&index=0&id=f39636be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39636be",
  null
  
)

export default component.exports